import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_ENDPOINTS } from '../constants/api.constant';
import { ApiResponse } from '../models/api-response.model';

export interface ClientRegistrationDocumentPayload {
  document_type: string;
  file_name: string;
  file_type: string;
  file_data_base64: string;
  notes?: string | null;
}

export interface ClientRegistrationPayload {
  entity_type: string;
  entity_name: string;
  username: string;
  email: string;
  mobile?: string | null;
  payload_json: Record<string, unknown>;
  documents: ClientRegistrationDocumentPayload[];
  submitted_by?: string | null;
}

export interface ClientRegistrationDocument {
  id: number;
  document_type: string;
  file_name: string;
  file_type: string;
  file_data_base64: string;
  notes: string | null;
  created_on: string;
}

export interface ClientRegistrationReview {
  id: number;
  action: string;
  remarks: string | null;
  acted_by: string | null;
  acted_on: string;
}

export interface ClientRegistrationRecord {
  id: number;
  registration_no: string;
  entity_type: string;
  entity_name: string;
  username: string;
  email: string;
  mobile: string | null;
  status: string;
  remarks: string | null;
  payload_json: Record<string, unknown>;
  submitted_by: string | null;
  reviewed_by: string | null;
  reviewed_on: string | null;
  is_active: boolean;
  created_on: string;
  updated_on: string | null;
  timestamp: string;
  documents: ClientRegistrationDocument[];
  reviews: ClientRegistrationReview[];
}

@Injectable({ providedIn: 'root' })
export class RegistrationFormService {
  private readonly http = inject(HttpClient);

  submit(payload: ClientRegistrationPayload): Observable<ApiResponse<ClientRegistrationRecord>> {
    return this.http.post<ApiResponse<ClientRegistrationRecord>>(API_ENDPOINTS.clientRegistrations.create, payload);
  }
}
